import React, { useEffect, useState } from "react";
import { Timer } from "lucide-react";

const pad = (n) => String(n).padStart(2, "0");
const hms = (ms) => {
  const s = Math.max(0, Math.floor(ms / 1000));
  return `${pad(Math.floor(s / 3600))}:${pad(Math.floor((s % 3600) / 60))}:${pad(s % 60)}`;
};
const L = {
  hu: { since: "Beküldés óta eltelt", stopped: "Döntés született", over: "SLA túllépve" },
  en: { since: "Elapsed since submission", stopped: "Decision issued", over: "SLA exceeded" },
  de: { since: "Seit Einreichung vergangen", stopped: "Entscheidung erlassen", over: "SLA überschritten" },
  fr: { since: "Écoulé depuis l'envoi", stopped: "Décision rendue", over: "SLA dépassé" },
  cs: { since: "Uplynulo od podání", stopped: "Rozhodnuto", over: "SLA překročeno" },
};

export function ElapsedTimer({ createdAt, decidedAt, closed, slaHours = 24, lang = "en", className = "" }) {
  const [now, setNow] = useState(Date.now());
  const stopped = closed;
  useEffect(() => {
    if (stopped) return undefined;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [stopped]);
  if (!createdAt) return null;
  const t = L[lang] || L.en;
  const end = stopped ? (decidedAt ? new Date(decidedAt).getTime() : null) : now;
  const ms = end ? end - new Date(createdAt).getTime() : null;
  const over = ms !== null && ms > slaHours * 3600000;
  const tone = over ? "border-red-500/60 bg-red-500/10 text-red-400" : stopped ? "border-zinc-700 bg-zinc-900 text-zinc-400" : "border-zinc-800 bg-zinc-900/70 text-zinc-100";
  return (
    <div data-testid="elapsed-timer" data-over={over ? "true" : "false"} data-stopped={stopped ? "true" : "false"}
      className={`inline-flex flex-col items-end rounded-lg border px-3 py-1.5 ${tone} ${over && !stopped ? "animate-pulse" : ""} ${className}`}>
      <span className="text-[9px] font-semibold uppercase tracking-wider opacity-70">{stopped ? t.stopped : over ? t.over : t.since}</span>
      <span className="flex items-center gap-1.5 font-mono text-[15px] font-semibold tabular-nums" data-testid="elapsed-timer-value">
        <Timer size={13} /> {ms !== null ? hms(ms) : "--:--:--"}
      </span>
    </div>
  );
}
